export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyAxHtpblxGDP07z2a9OIOlt6Kb3wXIGtas",
        authDomain: "schule-buttwil-pud6ga7dv.firebaseapp.com",
        databaseURL: "https://schule-buttwil-pud6ga7dv.firebaseio.com",
        projectId: "schule-buttwil-pud6ga7dv",
        storageBucket: "schule-buttwil-pud6ga7dv.appspot.com",
        messagingSenderId: "994622338119",
        appId: "1:994622338119:web:7c1b7567c16df51101ed62",
        measurementId: "G-Y9K7SK8074"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts